__turbopack_context__.v({
  "lineHeightLoose": "R76Jfa_lineHeightLoose",
  "lineHeightNormal": "R76Jfa_lineHeightNormal",
  "lineHeightRelaxed": "R76Jfa_lineHeightRelaxed",
  "lineHeightSnug": "R76Jfa_lineHeightSnug",
  "lineHeightTight": "R76Jfa_lineHeightTight",
  "text": "R76Jfa_text",
  "textL": "R76Jfa_textL",
  "textM": "R76Jfa_textM",
  "textS": "R76Jfa_textS",
  "textXL": "R76Jfa_textXL",
  "textXS": "R76Jfa_textXS",
  "textXXL": "R76Jfa_textXXL",
  "textXXS": "R76Jfa_textXXS",
});
